module.exports = __webpack_public_path__ + "static/lijn-47669886eb4b7132f7d8ea27e788bbed.png";